import { useMutation } from '@tanstack/react-query'
import { useNavigate } from '@tanstack/react-router'
import { ArrowRight, ArrowUpCircle } from 'lucide-react'

import { Button } from '@/components/button/button'

import { type ResUserQuery } from '@/lib/queries/business/v2/user/types'
import { createCustomerPortalSessionMutation } from '@/lib/queries/payment/v1/subscription/stripe/portal/mutations'

export interface PaymentsProps {
  user: ResUserQuery
}

export const Payments = ({ user }: PaymentsProps) => {
  const navigate = useNavigate()

  const { mutate: createCustomerPortalSession, isPending: isCustomerPortalSessionPending } = useMutation(
    createCustomerPortalSessionMutation
  )

  return (
    <div className="space-y-4">
      <div className="text-sm font-medium">Payments</div>
      {user.subscription ? (
        <Button
          className="flex w-full justify-between"
          variant="outline"
          disabled={isCustomerPortalSessionPending}
          onClick={() => {
            if (!user.subscription) {
              return
            }

            createCustomerPortalSession(
              {
                customerId: user.subscription.customerId,
                returnUrl: `${window.location.origin}/settings`,
              },
              {
                onSuccess: (data) => {
                  window.location.href = data
                },
              }
            )
          }}
        >
          Manage subscription
          <div className="flex">
            <ArrowRight size={21} />
          </div>
        </Button>
      ) : (
        <>
          <div className="mb-4 rounded-md border p-2 pl-3 text-sm font-medium text-foreground">
            You&apos;re not subscribed to any plan.
          </div>
          <button
            type="button"
            className="flex"
            onClick={() => {
              void navigate({ to: '/pricing' })
            }}
          >
            <div className="flex space-x-4 rounded-md bg-blue-50 p-2 pr-6">
              <ArrowUpCircle className="text-blue-700" size={20} />
              <div className="flex flex-col items-start">
                <div className="text-sm text-blue-600">View plans</div>
                <div className="text-xs text-blue-900">Upgrade for premium features.</div>
              </div>
            </div>
          </button>
        </>
      )}
    </div>
  )
}
